module.exports = __webpack_public_path__ + "static/media/checkmark.6781fdbc.png";